export default __webpack_public_path__ + "static/media/hills.0e6ffea0.svg";